/* Utils */
import { checkDevAndBranchOfEnv } from '@/utils/checkEnvironment'

/* Store */
import { useAnalyticsStore } from '@/store/analytics/analytics'

/* Types */
import { SetupParams } from '@/types/plugins'

import { MyTarget } from '@/services/metrics/models/MyTarget'
import { YandexMetric } from '@/services/metrics/models/YandexMetric'
/* Classes */
import ServiceMetrics from '@/services/metrics/ServiceMetrics'
import { getConfigOfMetric } from '@/services/metrics/utils/config'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin({
  name: 'initServiceMetrics',
  parallel: true,

  setup({ $config, $sentryCaptureException }: SetupParams) {
    const { MODE, MY_TARGET_ID } = $config.public

    // Отключаем пиксель для dev режима
    if (checkDevAndBranchOfEnv('Metrics', MODE)) return

    const router = useRouter()

    const analyticsStore = useAnalyticsStore()
    const { yandex, vk_pixel_id = '' } = analyticsStore.analytics

    const myTargetConfig = getConfigOfMetric(
      'MyTarget',
      { main_id: MY_TARGET_ID, city_id: String(vk_pixel_id) },
      false,
      $sentryCaptureException,
    )

    const yandexMetricConfig = getConfigOfMetric(
      'Yandex',
      yandex,
      true,
      $sentryCaptureException,
    )

    // Объявление всех инстансов метрик
    const myTarget = new MyTarget(myTargetConfig)
    const yandexMetric = new YandexMetric(yandexMetricConfig)

    const service = new ServiceMetrics(yandexMetric, myTarget)

    router?.afterEach((to, from) => {
      service?.eventPageView({ mt: 'pageView', ym: { to, from } })
    })

    return {
      provide: {
        metrics: service,
      },
    }
  },
})
